/**
 * דגל לשוניות ההגדרות שמחוץ לאפיון.
 *
 * אפיון 6.17 מונה במפורש מה **אינו** נכנס להגדרות: "התראות ודואר, שעות
 * מוקד כטאב נפרד, תסריטים, טאב לידים כפול, צ'אט צוות."
 *
 * ארבע הלשוניות האלה **לא נמחקו** — הקוד והנתונים ממשיכים לעבוד, הן פשוט
 * לא מוצגות כברירת מחדל:
 *   - שעות: הנתונים נצרכים ממילא באשף הקמפיין (`adminApi.hours()`), כך
 *     שההסתרה היא של הטאב הכפול ולא של היכולת.
 *   - לידים: קיים מסך לידים מלא ועצמאי (`/admin/leads`) — זה הכפל שהאפיון
 *     אוסר.
 *   - התראות ודואר / תסריטים: נשארים בקוד להדלקה נקודתית.
 *
 * איך מדליקים חזרה:
 *   1. בזמן build — `VITE_ADMIN_LEGACY_SETTINGS=1`.
 *   2. בזמן ריצה לבדיקה — `localStorage.setItem('merkaziya-admin-legacy-settings', '1')`
 *      ורענון, בלי build מחדש.
 *
 * אותו דפוס בדיוק כמו legacyAgentScreensEnabled בממשק הנציג.
 */

const STORAGE_KEY = 'merkaziya-admin-legacy-settings';

/** האם להציג את לשוניות ההגדרות שהאפיון מוציא (6.17). */
export function legacySettingsTabsEnabled(): boolean {
  if (import.meta.env.VITE_ADMIN_LEGACY_SETTINGS === '1') return true;
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // דפדפן שחוסם אחסון — נשארים על ברירת המחדל של האפיון.
    return false;
  }
}
